// @ts-nocheck
import { authenticated, api } from './index';

export const createCategory = (payload) =>
  authenticated(api).post('/settings_categories/', payload);

export const getCategories = (params) =>
  authenticated(api).get('/settings_categories/', { params });

export const updateCategory = (params, payload) =>
  authenticated(api).put(`/settings_categories/${params.categoryId}/`, payload);

export const deleteCategory = (params) =>
  authenticated(api).delete(`/settings_categories/${params.id}/`);

export const createNote = (payload) =>
  authenticated(api).post('/settings_category_notes/', payload);

export const updateNote = (params, payload) =>
  authenticated(api).put(`/settings_category_notes/${params.noteId}/`, payload);

export const deleteNote = (params) =>
  authenticated(api).delete(`/settings_category_notes/${params.noteId}/`);
